import React from 'react'
import { StyledLayout } from './styles'

const Layout = ({ children }) => {
  return (
    <StyledLayout container justifyContent='center' alignItems='center'>
      {children}
    </StyledLayout>
  )
}

export default Layout
